import type { Chapter, GameProgress } from '../types/game';

const icons = ['🏠', '❤️', '🌳', '🏰', '✨'];

export function ProgressMap({ chapters, progress }: { chapters: Chapter[]; progress: GameProgress }) {
  const rows: Chapter[][] = [];
  for (let index = 0; index < chapters.length; index += 6) rows.push(chapters.slice(index, index + 6));
  return (
    <nav className="progress-map" aria-label="Progreso por capítulos">
      {rows.map((row, rowIndex) => <div className="progress-map-row" key={rowIndex}>{row.map((chapter, index) => {
        const complete = chapter.modules.length > 0 && chapter.modules.every((module) => progress.completedModules.includes(module.id));
        const current = chapter.id === progress.currentChapterId && !complete;
        const state = complete ? 'complete' : current ? 'current' : 'locked';
        const globalIndex = rowIndex * 6 + index;
        return <div className="map-step-wrap" key={chapter.id}>
          {index > 0 && <span className={`map-line ${complete || current ? 'is-reached' : ''}`} />}
          <div className={`map-step is-${state}`} title={chapter.title} aria-label={`${chapter.title}: ${state === 'complete' ? 'completado' : state === 'current' ? 'actual' : 'bloqueado'}`}>
            <span>{complete ? '✓' : current ? icons[globalIndex % icons.length] : '🔒'}</span>
          </div>
        </div>;
      })}</div>)}
    </nav>
  );
}
